import React from 'react';
import PropTypes from 'prop-types';

function RightSection({ content }) {
  return (
    <>
      { React.cloneElement(content, {}) }
    </>
  )
}

RightSection.propTypes = {
  content: PropTypes.element.isRequired,
}

export default RightSection;
